import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconCheckCircleOutlineSvg } from "./IconCheckCircleOutlineSvg.mjs";
const IconCheckCircleOutline = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconCheckCircleOutlineSvg, ...iconProps });
};
export {
  IconCheckCircleOutline
};
